module.exports = __webpack_public_path__ + "static/media/health-insurance-card-img.9c5145d3.png";